import productDisplayLandscapeImg from "../../../assets/img/product-gg-3-display-landscape.png";
import productDisplayLandscapeImgWebp from "../../../assets/img/product-gg-3-display-landscape.webp";

const DontStop = () => (
    <section id="dont-stop">
        <div className="container-fluid gg-bg-solid-green-light">
            <div className="row justify-content-center align-content-center py-5">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius">
                    <div className="row justify-content-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-content-center text-center">
                            <picture>
                                <source srcSet={productDisplayLandscapeImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={productDisplayLandscapeImg} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center align-content-center">
                            <h3 className="fw-bold">Don’t stop just as it’s starting to work.</h3>
                            <h3 className="fw-bold gg-yellow mb-5">Don’t wait to come back and find out we're out.</h3>
                            <p className="my-3">
                                ✅  <b>Add 3 more bottles of GlucoGen<sup>17</sup> to your order</b><br />
                                ✅  <span className="fw-light">For just </span><b>$33 per bottle</b><span className="fw-light"> instead of $179</span><br />
                                ✅  <span className="fw-light">That’s a </span><b>$438 discount</b><span className="fw-light"> and </span><b>THE LAST CHANCE</b><span className="fw-light"> to protect your progress.</span><br />
                            </p>
                            <p className="fw-600 my-4">You’ve already taken the first step.<br />Now secure the next part of your journey…</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default DontStop;